var map = {
	"./Footer-Discord.png": 569,
	"./Footer-Facebook.png": 570,
	"./Footer-Medium.png": 571,
	"./Footer-Telegram.png": 572,
	"./Footer-Twitter.png": 573,
	"./Footer-Youtube.png": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1436;